const StepContainer = ({ step }) => (
  step
);

export default StepContainer;
